import React, { PropsWithChildren } from 'react';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { useTranslation } from 'react-i18next';
import './OrderConfirmationModal.scss';
import { de } from 'date-fns/locale';

type Props = {
  setOpenModal: (e: boolean) => void;
  onConfirmOrder?
  loading?: boolean
  orderAction: string
};

const OrderConfirmationModal: React.FC<Props> = (props: PropsWithChildren<Props>) => {
  const { t } = useTranslation();


  const getTitle = () => {
    switch (props.orderAction) {
      case 'rejected':
        return t('_client_order_rejection');
      case 'confirmed':
        return t('_client_order_confirmation');
      case 'updated':
        return t('_client_order_update');
      default:
        return '';
    }
  };

  return (
    <div className="order-confirmation-modal">
      <div className="modal-body">
        <div className="content">
          <div className="message">
            <p>{getTitle()}</p>
          </div>
          <div className="actions">
            <div className="no">
              <DefaultButton text={t('_no')} onClick={() => props.setOpenModal(false)} red />
            </div>
            <div className="yes">
              <DefaultButton text={t('_yes')} isloading={props.loading} onClick={() => props.onConfirmOrder()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationModal;
